// Centralized SEO configuration for mSuperTools

export const SITE_CONFIG = {
  name: 'mSuperTools',
  url: process.env.NEXT_PUBLIC_SITE_URL || 'https://convert176284.builtwithrocket.new',
  title: 'mSuperTools — Free PDF & Image Tools Online',
  description: 'Free everyday PDF and image tools. Compress images, merge PDFs, remove backgrounds, convert formats, and more — all in your browser. No uploads, no sign-up.',
  keywords: 'free image compressor, compress image online, merge PDF online, split PDF online, remove image background free, convert image to PDF, QR code scanner online',
  locale: 'en_US',
  twitterHandle: '@mSuperTools',
  ogImage: '/og-image.png',
};

export const CATEGORY_METADATA: Record<string, { title: string; description: string; slug: string }> = {
  'PDF Editing': {
    title: 'Free PDF Tools Online — Merge, Split, Compress & Edit PDFs',
    description: 'Merge, split, watermark, sign and compress PDF files in your browser. All tools are free and work entirely locally on your device.',
    slug: 'pdf',
  },
  'Image Edit': {
    title: 'Free Image Tools Online — Compress, Resize, Crop & Convert Images',
    description: 'Compress, resize, crop, convert and enhance images instantly. Remove backgrounds, convert formats, and more — all in your browser.',
    slug: 'image',
  },
  'Audio Tools': {
    title: 'Free Audio Tools Online — Convert, Trim, Merge & Edit Audio',
    description: 'Convert, trim, merge, record and enhance audio files entirely in your browser. Support for MP3, WAV, OGG, AAC and more.',
    slug: 'audio',
  },
  'Text Tools': {
    title: 'Free Text Tools Online — Count Words, Convert Case & Encode Text',
    description: 'Count words, convert case, clean text and encode/decode strings. Fast, free, and works entirely in your browser.',
    slug: 'text',
  },
  'Scan': {
    title: 'Free Scanning Tools Online — Scan Documents, ID Cards & Extract Text',
    description: 'Scan documents, ID cards and extract text using your camera or uploaded images. All processing happens locally on your device.',
    slug: 'scan',
  },
};

export function getCategorySlug(category: string): string {
  return CATEGORY_METADATA[category]?.slug || category.toLowerCase().replace(/\s+/g, '-');
}

export function getCategoryMetadata(category: string) {
  return CATEGORY_METADATA[category] || {
    title: category,
    description: `Free ${category} tools online. All processing happens in your browser.`,
    slug: category.toLowerCase().replace(/\s+/g, '-'),
  };
}

export function generateToolMetadata(toolTitle: string, toolDescription: string, keywords: string[]) {
  return {
    title: `${toolTitle} Online Free | mSuperTools`,
    description: toolDescription,
    keywords: [...keywords, 'free online tool', 'browser tool'].join(', '),
  };
}
